import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedAdjusterOtherAttachedImagesQueryParamsType,
  GetDamagedAdjusterOtherAttachedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterOtherAttachedImages/getDamagedAdjusterOtherAttachedImagesQuery.type';

export const getDamagedAdjusterOtherAttachedImagesFunction = (
  params: GetDamagedAdjusterOtherAttachedImagesQueryParamsType,
): Promise<GetDamagedAdjusterOtherAttachedImagesQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/${params.type}/images/additional/damaged/`,
    { params: { damaged_id: params.damaged_id } },
  );
};
